import type { WalkthroughStepKey, WalkthroughStepConfig } from '../types/guestWalkthrough.types'

export const WALKTHROUGH_STEPS = {
  ARENA: 'arena',
  DASHBOARD: 'dashboard',
  CREATE_BTN: 'create_btn',
  GAMES_LIST: 'games_list',
  MARKET_TAB: 'market_tab',
  MATCH_DETAILS: 'match_details',
  MATCH_DETAILS_NEXT: 'match_details_next',
  PREDICTING_REVIEW: 'predicting_review',
  PARTICIPANTS_PICK: 'participants_pick',
  PARTICIPANTS_SEND: 'participants_send',
  CHALLENGE_CARD: 'challenge_card',
} as const

export const WALKTHROUGH_STEP_ORDER: WalkthroughStepKey[] = [
  WALKTHROUGH_STEPS.ARENA,
  WALKTHROUGH_STEPS.DASHBOARD,
  WALKTHROUGH_STEPS.CREATE_BTN,
  WALKTHROUGH_STEPS.GAMES_LIST,
  WALKTHROUGH_STEPS.MARKET_TAB,
  WALKTHROUGH_STEPS.MATCH_DETAILS,
  WALKTHROUGH_STEPS.MATCH_DETAILS_NEXT,
  WALKTHROUGH_STEPS.PREDICTING_REVIEW,
  WALKTHROUGH_STEPS.PARTICIPANTS_PICK,
  WALKTHROUGH_STEPS.PARTICIPANTS_SEND,
  WALKTHROUGH_STEPS.CHALLENGE_CARD,
]

export const WALKTHROUGH_CONFIG: Record<WalkthroughStepKey, WalkthroughStepConfig> = {
  arena: {
    tooltip: 'Welcome to the Arena — this is where all your challenges live. Let\'s set up your first one!',
    monkeyMood: 'happy',
    showHandTap: false,
    showNextBtn: true,
    nextBtnLabel: 'Show me!',
  },
  dashboard: {
    tooltip:
      'This is your hub. Here you can see your activity and manage your friends and groups.',
    monkeyMood: 'idle',
    showHandTap: false,
    showNextBtn: true,
    nextBtnLabel: 'Got it!',
  },
  create_btn: {
    tooltip: 'Tap + to start a new challenge!',
    monkeyMood: 'happy',
    showHandTap: true,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  games_list: {
    tooltip: 'Tap a game to open it and see every bet type.',
    monkeyMood: 'idle',
    showHandTap: true,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  market_tab: {
    tooltip: 'These are the bet types. Tap the 1X2 tab to predict the match winner.',
    monkeyMood: 'happy',
    showHandTap: true,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  match_details: {
    tooltip: 'Now tap "1" to back the home team.',
    monkeyMood: 'happy',
    showHandTap: true,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  match_details_next: {
    tooltip: 'Great! Now press Next.',
    monkeyMood: 'happy',
    showHandTap: true,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  predicting_review: {
    tooltip:
      'Review your picks, and set the coin amount (stake) you put on every challenge. Then press Next.',
    monkeyMood: 'idle',
    showHandTap: false,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  participants_pick: {
    tooltip: 'Tap the monkey to challenge him!',
    monkeyMood: 'happy',
    showHandTap: true,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  participants_send: {
    tooltip: 'Awesome! Now press Send.',
    monkeyMood: 'happy',
    showHandTap: true,
    showNextBtn: false,
    nextBtnLabel: '',
  },
  challenge_card: {
    tooltip: 'Your Monkey challenge is live! Check back here in the Arena after the game ends to see who won.',
    monkeyMood: 'happy',
    showHandTap: false,
    showNextBtn: true,
    nextBtnLabel: 'Let\'s go!',
  },
}

/** Shown on games_list when no game can be spotlighted (no playable fixtures) — the tour ends gracefully here. */
export const NO_GAMES_FALLBACK_TOOLTIP =
  "There are no games to predict right now. You're all set — come back later to create your first challenge!"

/** Padding (px) added around the measured targetRect for the spotlight hole — gives fat-finger tolerance */
export const SPOTLIGHT_PADDING = 16
/** Half of the large border used for the dim overlay */
export const SPOTLIGHT_BORDER_WIDTH = 3000
/** Border radius of the spotlight hole */
export const SPOTLIGHT_BORDER_RADIUS = 12
